/* tslint:disable */
///////////////////////////////////////
//  Add format method to Date.prototype
///////////////////////////////////////

/*
 Copyright (c) 2005 Jacob Wright

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 */
export {};

declare global {
  interface Date {
    format(format);
    toTimezoneOffset();
    shortMonths;
    longMonths;
    shortDays;
    longDays;
  }
}

const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  longDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// defining patterns
const replaceChars = {
  // Day
  d: function() {
    return (this.getDate() < 10 ? '0' : '') + this.getDate();
  },
  D: function() {
    return shortDays[this.getDay()];
  },
  j: function() {
    return this.getDate();
  },
  l: function() {
    return longDays[this.getDay()];
  },
  N: function() {
    return (this.getDay() == 0 ? 7 : this.getDay());
  },
  S: function() {
    return (this.getDate() % 10 == 1 && this.getDate() != 11 ? 'st' : (this.getDate() % 10 == 2 && this.getDate() != 12 ? 'nd' : (this.getDate() % 10 == 3 && this.getDate() != 13 ? 'rd' : 'th')));
  },
  w: function() {
    return this.getDay();
  },
  z: function() {
    var d: any = new Date(this.getFullYear(), 0, 1);
    return Math.ceil((this - d) / 86400000);
  }, // Fixed now
  // Week
  W: function() {
    var target: any = new Date(this.valueOf());
    var dayNr = (this.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 3);
    var firstThursday = target.valueOf();
    target.setMonth(0, 1);
    if (target.getDay() !== 4) {
      target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
    }
    return 1 + Math.ceil((firstThursday - target) / 604800000);
  },
  // Month
  F: function() {
    return longMonths[this.getMonth()];
  },
  m: function() {
    return (this.getMonth() < 9 ? '0' : '') + (this.getMonth() + 1);
  },
  M: function() {
    return shortMonths[this.getMonth()];
  },
  n: function() {
    return this.getMonth() + 1;
  },
  t: function() {
    var d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 0).getDate();
  }, // Fixed now, gets #days of date
  // Year
  L: function() {
    var year = this.getFullYear();
    return (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0));
  },   // Fixed now
  o: function() {
    var d = new Date(this.valueOf());
    d.setDate(d.getDate() - ((this.getDay() + 6) % 7) + 3);
    return d.getFullYear();
  }, //Fixed now
  Y: function() {
    return this.getFullYear();
  },
  y: function() {
    return ('' + this.getFullYear()).substr(2);
  },
  // Time
  a: function() {
    return this.getHours() < 12 ? 'am' : 'pm';
  },
  A: function() {
    return this.getHours() < 12 ? 'AM' : 'PM';
  },
  B: function() {
    return Math.floor((((this.getUTCHours() + 1) % 24) + this.getUTCMinutes() / 60 + this.getUTCSeconds() / 3600) * 1000 / 24);
  }, // Fixed now
  g: function() {
    return this.getHours() % 12 || 12;
  },
  G: function() {
    return this.getHours();
  },
  h: function() {
    return ((this.getHours() % 12 || 12) < 10 ? '0' : '') + (this.getHours() % 12 || 12);
  },
  H: function() {
    return (this.getHours() < 10 ? '0' : '') + this.getHours();
  },
  i: function() {
    return (this.getMinutes() < 10 ? '0' : '') + this.getMinutes();
  },
  s: function() {
    return (this.getSeconds() < 10 ? '0' : '') + this.getSeconds();
  },
  u: function() {
    var m = this.getMilliseconds();
    return (m < 10 ? '00' : (m < 100 ? '0' : '')) + m;
  },
  // Timezone
  e: function(date) {
    return '';
  }, // doug.loftus@cbsinteractive.com replaced method body; orig as: return "Not Yet Supported";
  I: function() {
    var DST: any = null;
    for (var i = 0; i < 12; ++i) {
      var d: any = new Date(this.getFullYear(), i, 1);
      var offset: any = d.getTimezoneOffset();

      if (DST === null) DST = offset;
      else if (offset < DST) {
        DST = offset;
        break;
      }
      else if (offset > DST) break;
    }

    return (this.getTimezoneOffset() === DST) || 0;
  },
  O: function() {
    return (-this.getTimezoneOffset() < 0 ? '-' : '+') + (Math.abs(this.getTimezoneOffset() / 60) < 10 ? '0' : '') + (Math.abs(this.getTimezoneOffset() / 60)) + '00';
  },
  P: function() {
    return (-this.getTimezoneOffset() < 0 ? '-' : '+') + (Math.abs(this.getTimezoneOffset() / 60) < 10 ? '0' : '') + (Math.abs(this.getTimezoneOffset() / 60)) + ':00';
  }, // Fixed now
  T: function() {
    return this.toTimeString().replace(/^.+ \(?([^\)]+)\)?$/, '$1');
  },
  Z: function() {
    return -this.getTimezoneOffset() * 60;
  },
  // Full Date/Time
  c: function() {
    return this.format('Y-m-d\\TH:i:sP');
  }, // Fixed now
  r: function() {
    return this.toString();
  },
  U: function() {
    return this.getTime() / 1000;
  },
};

// Simulates PHP's date function
Date.prototype.format = function(format) {
  var date = this;
  return format.replace(/(\\?)(.)/g, function(_, esc, chr) {
    return (esc === '' && replaceChars[chr]) ? replaceChars[chr].call(date) : chr;
  });
};

Date.prototype.toTimezoneOffset = function() {
  return this.setTime(this.getTime() + this.getTimezoneOffset() * 60 * 1000);
};



// WEBPACK FOOTER //
// ./src/utils/date/date-prototype.utils.ts